import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from "@angular/http";
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { User } from './user.model';
import { AppSettings } from '../shared/appSettings'

@Injectable()
export class UserService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(private http: HttpClient) { }

  // registerUser(user: User) {
  //   const body: User = {
  //     UserName: user.UserName,
  //     Password: user.Password,
  //     Email: user.Email,
  //     FirstName: user.FirstName,
  //     LastName: user.LastName
  //   }
  //   var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
  //   return this.http.post(this.rootUrl + '/api/User/Register', body, { headers: reqHeader });
  // }

  userAuthentication(userName, password, otpCode) {
    var data = "username=" + userName + "&password=" + password + "/" + otpCode + "&grant_type=password";
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + '/token', data, { headers: reqHeader });
  }

  getUserOTP(userName) {
    const body: User = {
      UserName: userName,
      Password: "",
      Email: "",
      FirstName: "",
      LastName: ""
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + '/api/User/Otp', body, { headers: reqHeader });
  }

  getUserClaims() {
    return this.http.get(this.rootUrl + '/api/GetUserClaims');
  }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/shared/user.service.ts